import { getFreeIncluded } from "common";
import React from "react";
import { ProductIncludedItem } from "./ProductIncludedItem";
export function ProductsIncluded({ product }) {
    var _a;
    return (React.createElement("div", { className: "free-products-list" }, (_a = getFreeIncluded(product)) === null || _a === void 0 ? void 0 : _a.ids.map((included, index) => {
        return React.createElement(ProductIncludedItem, { key: index, included: included });
    })));
}
